import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalConfigService {

  constructor(@Inject('apiEndPoint') private apiEndPoint: string, private httpClient: HttpClient) { }

  getFaqs(){
    return this.httpClient.get(`${this.apiEndPoint}/gwdevice/xedge_faq/_search?size=1000`);
  }

  createFaqs(payload){
    return this.httpClient.post(`${this.apiEndPoint}/gwdevice/xedge_faq/_create`,payload);
  }

  updateFaqs(id,payload){
    return this.httpClient.put(this.apiEndPoint + `/gwdevice/xedge_faq/${id}/_update`, payload);
  }

  deleteFaq(id){
    return this.httpClient.delete(this.apiEndPoint + `/gwdevice/xedge_faq/${id}`);
  }

  deploymentName(){
    const filter = {"query":{"bool":{"must":[
        {"query_string":{ "query":"deployment_name", "type": "phrase", "fields": ["_id"] } }
      
    ]
       }},"sort":{"_kuzzle_info.createdAt":"desc"}}

    return this.httpClient.post(`${this.apiEndPoint}/gwdevice/configparam/_search`, filter)
  }

  
  createDeploymentName(name:any){
    const filter = {"name":name};
    return this.httpClient.post(`${this.apiEndPoint}/gwdevice/configparam/deployment_name/_create`, filter)
  }

  updateDeploymentName(name:any){
    const filter = {"name":name};
    return this.httpClient.patch(`${this.apiEndPoint}/gwdevice/configparam/deployment_name/_update`, filter)
  }
  
  saveThresHolds(json:any){
    return this.httpClient.patch(`${this.apiEndPoint}/gwdevice/configparam/threshold_values/_update`, json)
  }
  getThresHolds(){
    return this.httpClient.get(`${this.apiEndPoint}/gwdevice/configparam/threshold_values`)
  }

  deleteDeploymentName(){
    return this.httpClient.delete(`${this.apiEndPoint}/gwdevice/configparam/deployment_name`)
  }

  uploadPolicyMatrix(file: File) {
    const form = new FormData();
    form.append('profile', file);
    return this.httpClient.post(`${this.apiEndPoint}/xedge/v1/policy-matrix/profile`, form);
  }

  getPolicyMatrixProfiles() {
    return this.httpClient.get(`${this.apiEndPoint}/gwdevice/policy_matrix/_search?size=1000`);
  }

  deletePolicyProfile(id: string) {
    return this.httpClient.delete(`${this.apiEndPoint}/gwdevice/policy_matrix/${id}`);
  }

  cleanupProfileScheduledWalktests(profileId: string) {
    return this.httpClient.post(`${this.apiEndPoint}/_/2.1/cleanup_profile_scheduled_walktests`, { profile_id: profileId });
  }

  getScheduledWalktestCount(profileId: string) {
    const payload = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: profileId,
                type: 'phrase',
                fields: ['payload.devices.condition.profile_id'],
              },
            },
            { range: { '_kuzzle_info.createdAt': { gte: 0 } } },
          ],
        },
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_count`,
      payload,
    );
  }

  searchProfileRevisions(profileId: string) {
    const payload = {
      query: { term: { 'profile_id.keyword': profileId } },
      sort: [{ revision: 'desc' }]
    };
    return this.httpClient.post(`${this.apiEndPoint}/gwdevice/policy_matrix/_search?size=1000`, payload);
  }

  updatePolicyProfile(id: string, payload: any) {
    return this.httpClient.patch(`${this.apiEndPoint}/gwdevice/policy_matrix/${id}/_update`, payload);
  }

  getPolicyMatrixTemplate() {
    return this.httpClient.get(`${this.apiEndPoint}/xedge/v1/policy-matrix/template`);
  }
}
